import React from 'react';
import { motion } from 'framer-motion';
import { FiBox, FiHome, FiSettings, FiTool, FiLayout, FiZap } from 'react-icons/fi';

export default function Services() {
  const services = [
    {
      id: 1,
      title: 'Residential House Construction in Chennai',
      
      description: 'Looking for trusted residential house construction in Chennai? Sankar Designing & Construction builds premium 2BHK, 3BHK, villas, and independent houses across Chennai — including OMR, Anna Nagar, Tambaram, and Velachery. We use quality materials, skilled engineers, and deliver on time within budget. Get a free consultation today!',
      icon: FiHome,
    },
    {
      id: 2,
      title: 'Commercial Building Construction Chennai',
      description: 'Sankar Designing & Construction offers expert commercial construction services in Chennai. From office buildings and retail spaces to warehouses and restaurant build-outs, we deliver high-quality projects on time and within budget. Serving businesses across Chennai including Anna Nagar, OMR, Ambattur, and Guindy. Contact us today for a free site consultation!',
      icon: FiLayout,
    },
    {
      id: 3,
      title: 'Villa & Duplex Construction Chennai',
      description: 'Build your dream luxury villa or duplex home in Chennai with Sankar Designing & Construction. We offer complete turnkey construction solutions with modern architectural designs, premium finishes, and high-quality materials. From planning to handover, we handle everything — including interior design, flooring, and elevation work. Serving areas across Chennai including ECR, OMR, Anna Nagar, and Velachery. Contact us today for a free estimate!',
      icon: FiBox,
    },
    {
      id: 4,
      title: 'Renovation & Remodeling Services Chennai',
      description: 'Complete renovation services to breathe new life into your existing space. We specialize in kitchen remodeling, bathroom renovation, and full home makeovers across Chennai. Affordable pricing, premium materials, and on-time delivery guaranteed',
      icon: FiTool,
    },
    {
      id: 5,
      title: 'Interior Design & Finishing Chennai',
      description: 'Modern interior design solutions that transform your home or office into a beautiful, functional space. We offer complete finishing services including flooring, painting, false ceiling, and furniture fitting across Chennai. Affordable packages with premium quality guaranteed',
      icon: FiSettings,
    },
    {
      id: 6,
      title: 'Turnkey Construction Projects Chennai',
      description: 'Complete end-to-end construction solutions from planning, design, and execution to final handover. We handle full project management for residential and commercial projects across Chennai — including approvals, contractor coordination, quality checks, and on-time delivery. Trusted by 100+ happy clients in Chennai.',
      icon: FiZap,
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 },
    },
  };

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h1>Construction Services in Chennai</h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Comprehensive construction and design solutions tailored to your needs across Chennai and surrounding areas
          </p>
        </motion.div>

        {/* Services Grid */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {services.map((service) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={service.id}
                variants={itemVariants}
                className="group p-8 bg-white border-2 border-gray-200 rounded-lg hover:border-black hover:shadow-xl transition-all duration-300 cursor-pointer"
                whileHover={{ y: -8 }}
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <div className="w-14 h-14 bg-black rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                      <Icon className="text-white" size={24} />
                    </div>
                    <h2 className="text-xl font-bold text-black mb-2">{service.heading}</h2>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">{service.title}</h3>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">{service.description}</p>
                
                {/* Hover Indicator */}
                <motion.div
                  className="mt-4 text-black font-semibold text-sm flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity"
                  initial={{ x: -10 }}
                  whileHover={{ x: 0 }}
                >
                  Learn more →
                </motion.div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>

      {/* SEO Content - Hidden from users but visible to search engines */}
      <div className="sr-only">
        <h3>Construction Services in Chennai - Sankar Construction</h3>
        <p>Sankar Construction offers comprehensive construction services in Chennai, Tamil Nadu. Our expert team provides residential construction, commercial construction, and interior design services across Chennai and surrounding areas.</p>

        <h4>Residential Construction Services</h4>
        <p>Custom home building, villa construction, apartment construction, bungalow construction, duplex construction, and row house construction in Chennai. We specialize in modern residential projects with premium materials and quality workmanship.</p>

        <h4>Commercial Construction Services</h4>
        <p>Office building construction, retail store construction, warehouse construction, restaurant build-out, medical clinic construction, and corporate office construction in Chennai. Professional commercial construction services for businesses.</p>

        <h4>Interior Design Services</h4>
        <p>Kitchen remodeling, bathroom design, living room makeover, bedroom renovation, home office setup, dining area design, and basement finishing in Chennai. Complete interior design solutions for modern homes and offices.</p>

        <h4>Renovation and Remodeling</h4>
        <p>Home renovation, office renovation, space planning, and complete remodeling services in Chennai. Transform your existing space with our expert renovation services.</p>
      </div>
    </section>
  );
}
